import { useMemo } from 'react'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { useLingui } from '@lingui/react/macro'
import { InfoIcon } from 'lucide-react'

export const MinBilledMinutes = ({
	billedMinutes,
}: {
	billedMinutes: number
}) => {
	const { t } = useLingui()

	const billedMinutesFormatted = useMemo(() => {
		return dateTimeUtils
			.duration(billedMinutes || 0, 'minutes')
			.format('H[h]mm')
			.replace('h00', 'h')
	}, [billedMinutes])

	return (
		<div className='flex items-center gap-2 border-t px-4 py-2 text-xs leading-tight text-gray-500'>
			<InfoIcon className='!size-4 shrink-0' />
			{t`Le minimum de facturation pour cet espace est de ${billedMinutesFormatted}, toute réservation inférieure à ${billedMinutesFormatted} sera facturée au tarif ${billedMinutesFormatted}.`}
		</div>
	)
}
